import { render, staticRenderFns } from "./DashPatients.vue?vue&type=template&id=7b4f5cd3&scoped=true"
import script from "./DashPatients.vue?vue&type=script&lang=js"
export * from "./DashPatients.vue?vue&type=script&lang=js"
import style0 from "./DashPatients.vue?vue&type=style&index=0&id=7b4f5cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f5cd3",
  null
  
)

export default component.exports